import { LOCAL } from '../../constants/FJEvnConstant';

const environment = import.meta.env.MODE;
export default {
    libPath: environment === LOCAL ? `/public/lib/` : `/app/ai-tools/lib/`,
    originalImageKey: 'ai/input/depth-map/',
    resultImageKey: 'ai/export/depth-map/',
    historyListType: 8,
    freeLimitType: 'depth-map',
    currentMenuName: '3d-photo-animation',
};
